import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap'
import Card from '../../../components/Card'
import { toast } from 'react-toastify';
import { API_COMPANY_PROFILE, API_PARENT_COMPANY_LICENCE, API_MANAGE_LOCATIONS_LIST, API_MANAGE_GROUP_LISTING, API_CALL_STRATEGIES_MASTER_LIST, API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST, API_USER_COUNTRY_CODE_DIRECTIONS_BY_COMPANY } from '../../../service/url';
import { postApiCall, getApiCall, fetchAndSetFlashMessage } from '../../../service/httpCall';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES, USER_ROLES, MODULE_ACL, FLASH_MESSAGE_ACTION_OBJECT } from '../../../utilities/constant';
import RenderUserCompanyFields from "../../../components/partials/dashboard/users/company";
import { validatePhone } from "../../../utilities/helpers";
import Select from 'react-select';
import { Storage } from "../../../utilities/setting";
import { FiPhone, FiUsers, FiShare2, FiInfo, FiActivity, FiSmartphone } from "react-icons/fi";
import { FaBuilding, FaHeadset } from "react-icons/fa";
import LicenceAllocationPanel from "../../../components/partials/dashboard/company/LicenceAllocationPanel";
import "../../../assets/custom/css/custom.css";

const CompanyUpdate = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyPincode, setCompanyPincode] = useState("");
  const [companyLicence, setCompanyLicence] = useState("");
  const [callCenterAdminTeamlead, setCallCenterAdminTeamlead] = useState(0);
  const [agent, setAgent] = useState(0);
  const [liveAgent, setLiveAgent] = useState(0);
  const [channel, setChannel] = useState(0);
  const [asReseller, setAsReseller] = useState(0);
  const [asCompany, setAsCompany] = useState(0);
  const [availableLicence, setAvailableLicence] = useState({});
  const [errors, setErrors] = useState({});
  const [totalLicence, setTotalLicence] = useState({});
  const [usedLicence, setUsedLicence] = useState({});
  const [loginUserRole, setLoginUserRole] = useState(null);
  const [parentLicence, setParentLicence] = useState(null);
  const [initialLicence, setInitialLicence] = useState({});
  const [selectedCallStrategy, setSelectedCallStrategy] = useState([]);
  const [countryCodeDirections, setCountryCodeDirections] = useState([]);
  const [selectedCountryCodeDirections, setSelectedCountryCodeDirections] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [locations, setLocations] = useState([]);
  const [callStrategies, setCallStrategies] = useState([]);
  const [groups, setGroups] = useState([]);
  const [isResellerCompany, setIsResellerCompany] = useState(null);
  const [isOwnCompany, setIsOwnCompany] = useState(null);
  const [notes, setNotes] = useState([]);
  const [cps, setCps] = useState(0);
  const [mobile, setMobile] = useState(0);


  function getProfileApiUrl() {
    return API_COMPANY_PROFILE.replace(':id', id);
  }

  useEffect(() => {
    getUser();
  }, [])

  useEffect(() => {
    const profileApiUrl = getProfileApiUrl();
    getApiCall(profileApiUrl, {})
      .then(resp => {
        setCompanyName(resp.name)
        setCompanyPhone(resp.phone)
        setCompanyAddress(resp.address)
        setCompanyPincode(resp.pincode)
        setIsOwnCompany(resp.is_own_company);
        setIsResellerCompany(resp.is_reseller_company);

        // Fix: Access the licence object correctly
        // const licence = resp?.subUserLicenceId || {};
        // const available = licence?.available_licence || {};
        // const total = licence?.total_licence || {};

        // setAvailableLicence(available);
        // setTotalLicence(total);

        // // Calculate used licence
        // const calculatedUsed = Object.fromEntries(
        //    Object.keys(total).map(key => [key, total[key] - (available[key] || 0)])
        // );

        // setUsedLicence(calculatedUsed);

        // // Set individual licence values
        // setCallCenterAdminTeamlead(available.role_ccadmin || 0);
        // setAgent(available.role_ccagent || 0);
        // setLiveAgent(available.live_agent || 0);
        // setChannel(available.channel || 0);
        // setCps(available.cps || 0);
        // setAsReseller(available.reseller || 0);
        // setAsCompany(available.company || 0);

        const licence = resp?.subUserLicenceId || {};
        const available = licence?.available_licence || {};
        const total = licence?.total_licence || {};
        const used = licence?.used_licence || {};

        setAvailableLicence(available);
        setTotalLicence(total);

        // const calculatedUsed = Object.fromEntries(
        //   Object.keys(total).map(key => [key, total[key] - (available[key] || 0)])
        // );
        setUsedLicence(used);

        // current values (what user sees/edits)
        const currentValues = {
          role_ccadmin: available.role_ccadmin || 0,
          role_ccagent: available.role_ccagent || 0,
          live_agent: available.live_agent || 0,
          channel: available.channel || 0,
          cps: available.cps || 0,
          mobile: available.mobile || 0,
          reseller: available.reseller || 0,
          company: available.company || 0,
        };

        setCallCenterAdminTeamlead(currentValues.role_ccadmin);
        setAgent(currentValues.role_ccagent);
        setLiveAgent(currentValues.live_agent);
        setChannel(currentValues.channel);
        setCps(currentValues.cps);
        setMobile(currentValues.mobile);
        // setAsReseller(currentValues.reseller);
        setAsCompany(currentValues.company);

        // save initial values for comparison
        setInitialLicence(currentValues);

        const selectedGroups = resp.companyGroups.map(item => item.groups.group_id);

        const selectedLocations = resp.companyLocations.map(item => item.locations.location_id);

        const selectedStrategies = resp.companyCallStrategies.map(item => item.strategyMaster.id);


        setSelectedGroup(selectedGroups)
        setSelectedLocation(selectedLocations)
        setSelectedCallStrategy(selectedStrategies)

        if (Array.isArray(resp.companyCountryCodeDirections)) {
          setSelectedCountryCodeDirections(
            resp.companyCountryCodeDirections
              .map(item => item.country_code_direction_id)
              .filter(Boolean)
          );
        } else {
          getApiCall(API_USER_COUNTRY_CODE_DIRECTIONS_BY_COMPANY(id), {})
            .then(data => {
              const ids = Array.isArray(data)
                ? data.map(item => item.country_code_direction_id).filter(Boolean)
                : [];
              setSelectedCountryCodeDirections(ids);
            })
            .catch(() => {});
        }
      }).catch(onError);
  }, [id]);

  useEffect(() => {
    const fetchMetaData = async () => {
      const user = JSON.parse(Storage.getItem("user"));

      try {
        const [locationsData, groupsData, callStrategiesData, countryCodeDirectionsData] = await Promise.all([
          getApiCall(API_MANAGE_LOCATIONS_LIST, {}),
          getApiCall(API_MANAGE_GROUP_LISTING, {}),
          getApiCall(API_CALL_STRATEGIES_MASTER_LIST, {}),
          getApiCall(API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST, {}).catch(() => [])
        ]);

        setCallStrategies(callStrategiesData?.map(strategy => ({
          value: strategy.id,
          label: strategy.name
        })) || []);

        setCountryCodeDirections(Array.isArray(countryCodeDirectionsData) ? countryCodeDirectionsData : []);

        if (user.role === USER_ROLES.SUPERADMIN) {
          // Normalize API data -> always { value, label }
          const normalizedLocations =
            (locationsData || []).map(loc => ({
              value: loc.location_id,
              label: loc.location_name,
            })) || [];

          const normalizedGroups =
            (groupsData || []).map(g => ({
              value: g.group_id,
              label: g.group_name,
            })) || [];

          setLocations(normalizedLocations);
          setGroups(normalizedGroups);
        } else {
          // Normalize user-based data -> always { value, label }
          const userGroups =
            groupsData.map(ug => ({
              value: ug.group_id,
              label: ug.group_name,
            })) || [];
          const userLocations =
            locationsData.map(ul => ({
              value: ul.location_id,
              label: ul.location_name,
            })) || [];

          setGroups(userGroups);
          setLocations(userLocations);
        }
      } catch (error) {
        console.error("Error fetching Dialer groups/locations:", error);
      }
    };

    fetchMetaData();

    fetchAndSetFlashMessage(
      msg => msg.module_name === MODULE_ACL.COMPANY && msg.action === FLASH_MESSAGE_ACTION_OBJECT.EDIT && msg.type === 'Note',
      setNotes
    );
  }, []);


  // useEffect( () => {

  //    if(toastProps){
  //       setShowToast(true);
  //    }

  // }, [toastProps]);
  const validateInput = (value, key) => {
    const num = Number(value);

    // NaN â†’ treat as 0
    if (Number.isNaN(num)) return 0;

    // âŒ negative not allowed for anyone
    if (num < 0) {
      setErrors(prev => ({ ...prev, [key]: "Value cannot be negative" }));
      return num;
    }

    /* ================= SUPER ADMIN ================= */
    if (loginUserRole === USER_ROLES.SUPERADMIN) {

      // Only business rule that still applies
      // if (key === "live_agent" && num > 10) {
      //   setErrors(prev => ({
      //     ...prev,
      //     [key]: "Live Agent cannot exceed 10",
      //   }));
      //   return num;
      // }

      // âœ… NO upper limit checks
      setErrors(prev => ({ ...prev, [key]: "" }));
      return num;
    }

    /* ================= NON-SUPER ADMIN ================= */

    const licenceKeyMap = {
      role_ccadmin: "role_ccadmin",
      agent: "role_ccagent",
      live_agent: "live_agent",
      channel: "channel",
      cps: "cps",
      mobile: "mobile",
      reseller: "reseller",
      company: "company",
    };

    const licenceKey = licenceKeyMap[key];
    const initialValue = Number(initialLicence?.[licenceKey] || 0);
    const parentAvailable =
      parentLicence?.available_licence?.[licenceKey];

    // Allow keeping existing value
    if (num === initialValue) {
      setErrors(prev => ({ ...prev, [key]: "" }));
      return num;
    }

    // Parent availability check
    const diff = num - initialValue;

    if (
      parentAvailable !== undefined &&
      diff > parentAvailable &&
      diff > 0
    ) {
      setErrors(prev => ({
        ...prev,
        [key]: `You can increase only ${parentAvailable} more or Keep Existing value`,
      }));
      return num;
    }


    // Live agent rule
    // if (key === "live_agent" && num > 10) {
    //   setErrors(prev => ({
    //     ...prev,
    //     [key]: "Live Agent cannot exceed 10",
    //   }));
    //   return num;
    // }

    setErrors(prev => ({ ...prev, [key]: "" }));
    return num;
  };

  const getLicenceMax = (key) => {
    if (loginUserRole === USER_ROLES.SUPERADMIN) {
      return undefined;
    }
    const avail = parentLicence?.available_licence;
    if (avail == null) return undefined;
    const map = {
      role_ccadmin: avail.role_ccadmin,
      agent: avail.role_ccagent,
      live_agent: avail.live_agent,
      channel: avail.channel,
      cps: avail.cps,
      mobile: avail.mobile,
      company: avail.company,
    };
    const max = map[key];
    const initialKey = key === "agent" ? "role_ccagent" : key;
    const initialValue = Number(initialLicence?.[initialKey] || 0);
    if (max === undefined || max === null) return undefined;
    return initialValue + max;
  };

  const stepLicence = (key, current, setter, delta) => {
    const next = Math.max(0, (parseInt(String(current), 10) || 0) + delta);
    setter(validateInput(String(next), key));
  };

  const canIncrementLicence = (key, current) => {
    const max = getLicenceMax(key);
    if (max === undefined || max === null) return true;
    return (parseInt(String(current), 10) || 0) < max;
  };

  async function getUser() {
    try {
      const user = JSON.parse(Storage.getItem('user'));
      if (user) {
        setLoginUserRole(user.role);
      }
    } catch (err) {
      console.log(err)
    }
  }

  function validateCompanyFields() {
    let valid = true;

    if (!companyName.trim()) {
      valid = false;
      toast.error("Company name required");
    } else if (!validateCompanyPhone(companyPhone)) {
      valid = false;
      // setToastProps({
      //     message: "Company phone invalid format",
      //     type: "danger",
      toast.error("Company phone invalid format");
    } else if (!companyPincode.trim()) {
      valid = false;
      toast.error("Company pincode required");
    } else if (!/^\d{6}$/.test(companyPincode)) {
      valid = false;
      toast.error("Company pincode must be exactly 6 digits");
    } else if (!companyAddress.trim()) {
      valid = false;
      toast.error("Company address required");
    }

    return valid;
  }
  async function submitForm() {
    setButtonDisable(true);

    if (!validateCompanyFields()) {
      setButtonDisable(false);
      return;
    }

    // Check if there are any validation errors
    if (Object.values(errors).some(error => error !== "")) {
      toast.error("Please fix all validation errors before submitting");
      setButtonDisable(false);
      return;
    }

    // Only keep live agent validation
    //  if (liveAgent > 10) {
    //     toast.error("Live Agent cannot exceed 10");
    //     setButtonDisable(false);
    //     return;
    //  }

    const params = {
      name: companyName,
      phone: companyPhone,
      address: companyAddress,
      pincode: companyPincode,
      is_reseller_company: isResellerCompany,
      is_own_company: isOwnCompany,
      licence: {
        role_ccadmin: callCenterAdminTeamlead,
        role_ccagent: agent,
        live_agent: liveAgent,
        channel,
         cps: cps,
        mobile: mobile,
        reseller: 0, // use asReseller when reseller box uncommented
        company: isOwnCompany ? 0 : asCompany,
      }
    }

    if (selectedGroup && selectedGroup.length > 0) {
      params.groups = Array.isArray(selectedGroup)
        ? selectedGroup.map(Number)
        : [Number(selectedGroup)];
    }

    if (selectedLocation && selectedLocation.length > 0) {
      params.locations = Array.isArray(selectedLocation)
        ? selectedLocation.map(Number)
        : [Number(selectedLocation)];
    }
    if (selectedCallStrategy && selectedCallStrategy.length > 0) {
      params.call_strategies = Array.isArray(selectedCallStrategy)
        ? selectedCallStrategy.map(Number)
        : [Number(selectedCallStrategy)];
    }
    params.country_code_directions = Array.isArray(selectedCountryCodeDirections)
      ? selectedCountryCodeDirections.map(Number)
      : [];

    const profileApiUrl = getProfileApiUrl();
    postApiCall(profileApiUrl, params)
      .then(onCompanyUpdateSuccess)
      .catch(onError);
  }



  function onCompanyUpdateSuccess(resp) {
    toast.success("Company updated successfully");
    setTimeout(() => {
      navigate(`/${ROUTES.COMPANIES.LIST}`);
    }, 1500);
  }

  function onError(err) {
    setButtonDisable(false);
    toast.error(JSON.stringify(err));
  }

  useEffect(() => {
    getApiCall(API_PARENT_COMPANY_LICENCE).then((resp) => {
      setParentLicence(resp?.parentLicence);
    }).catch((error) => {
      toast.error(JSON.stringify(error));
    });
  }, []);

  function validateCompanyPhone(phone) {
    if (!phone) return false;
    return /^[0-9]{10}$/.test(phone.trim());
  }

  const licencePanelNote =
    notes.find((n) => Number(n.priority) === 1)?.message ?? "";

  return (
    <>
      <div className="company-edit-page">
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-none" />
              <Card.Body className="user-create-form-card">
                <div className="new-user-info company-create-form company-edit-form">
                  <div className="user-create-form__hero">
                    <div className="user-create-form__hero-left">
                      <span className="user-create-form__hero-icon" aria-hidden="true">
                        <FaBuilding size={22} />
                      </span>
                      <div>
                        <h5 className="user-create-form__hero-title">Edit Company Information</h5>
                        <p className="user-create-form__hero-subtitle">
                          Update company profile, assignments, and licence allocation.
                        </p>
                      </div>
                    </div>
                    <div className="user-create-form__required-note">
                      <FiInfo size={14} aria-hidden="true" />
                      <span>
                        All fields marked with <span className="text-danger">*</span> are required
                      </span>
                    </div>
                  </div>

                  <form>
                    <RenderUserCompanyFields
                      isEditMode={true}
                      company_name={companyName}
                      company_phone={companyPhone}
                      company_pincode={companyPincode}
                      company_address={companyAddress}
                      set_company_name={setCompanyName}
                      set_company_phone={setCompanyPhone}
                      set_company_pincode={setCompanyPincode}
                      set_company_address={setCompanyAddress}
                      isResellerCompany={isResellerCompany}
                      isOwnCompany={isOwnCompany}
                      locations={locations}
                      selectedLocation={selectedLocation}
                      setSelectedLocation={setSelectedLocation}
                      countryCodeDirections={countryCodeDirections}
                      selectedCountryCodeDirections={selectedCountryCodeDirections}
                      setSelectedCountryCodeDirections={setSelectedCountryCodeDirections}
                    />

                    <div className="row g-3 mt-1 company-edit-form__row">
                      <Form.Group className="col-12 col-lg-6 form-group mb-0">
                        <Form.Label>Call Strategy</Form.Label>
                        <div className="ccf-input-with-icon">
                          <span className="ccf-input-with-icon__icon">
                            <FiPhone size={18} />
                          </span>
                          <Select
                            className="theme-react-select ccf-select-in-icon"
                            classNamePrefix="theme-react-select"
                            options={callStrategies}
                            value={callStrategies.filter((l) =>
                              selectedCallStrategy.includes(l.value)
                            )}
                            onChange={(selected) =>
                              setSelectedCallStrategy(selected.map((s) => s.value))
                            }
                            isMulti
                            placeholder="Select Call Strategy"
                          />
                        </div>
                      </Form.Group>
                      <Form.Group className="col-12 col-lg-6 form-group mb-0">
                        <Form.Label>Dialer Group</Form.Label>
                        <div className="ccf-input-with-icon">
                          <span className="ccf-input-with-icon__icon">
                            <FiUsers size={18} />
                          </span>
                          <Select
                            className="theme-react-select ccf-select-in-icon"
                            classNamePrefix="theme-react-select"
                            options={groups}
                            value={groups.filter((g) => selectedGroup.includes(g.value))}
                            onChange={(selected) =>
                              setSelectedGroup(selected.map((s) => s.value))
                            }
                            isMulti
                            placeholder="Select Dialer Group"
                          />
                        </div>
                      </Form.Group>
                    </div>

                    <div className="company-type-section-v2 company-edit-form__type-section">
                      <Form.Label className="ccf-field-label d-block">Company type</Form.Label>
                      <div className="row g-3">
                        {isResellerCompany && (
                          <div className="col-12 col-md-6">
                            <div className="company-type-card-v2 is-selected company-edit-form__type-card--readonly">
                              <span className="company-type-card-v2__radio" aria-hidden="true" />
                              <span className="company-type-card-v2__icon company-type-card-v2__icon--reseller">
                                <FaBuilding size={20} />
                              </span>
                              <div className="company-type-card-v2__body">
                                <div className="company-type-card-v2__title">Reseller Company</div>
                                <div className="company-type-card-v2__desc">
                                  Can create and manage child companies
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {isOwnCompany && (
                          <div className={isResellerCompany ? "col-12 col-md-6" : "col-12 col-md-6"}>
                            <div className="company-type-card-v2 is-selected company-edit-form__type-card--readonly">
                              <span className="company-type-card-v2__radio" aria-hidden="true" />
                              <span className="company-type-card-v2__icon company-type-card-v2__icon--enduser">
                                <FiUsers size={22} />
                              </span>
                              <div className="company-type-card-v2__body">
                                <div className="company-type-card-v2__title">End User</div>
                                <div className="company-type-card-v2__desc">
                                  Operates as a single end-user company
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <LicenceAllocationPanel
                      showNote={Boolean(licencePanelNote)}
                      noteMessage={licencePanelNote}
                      footerNote={
                        loginUserRole !== USER_ROLES.SUPERADMIN
                          ? notes.find((n) => Number(n.priority) === 2)?.message ?? ""
                          : ""
                      }
                      columns={[
                        {
                          key: "role_ccadmin",
                          icon: FaHeadset,
                          iconModifier: "callcenter",
                          title: "Call Centers",
                          description: "Number of call centers",
                          value: parseInt(String(callCenterAdminTeamlead), 10) || 0,
                          onChange: (val) =>
                            setCallCenterAdminTeamlead(validateInput(String(val), "role_ccadmin")),
                          onDecrement: () =>
                            stepLicence("role_ccadmin", callCenterAdminTeamlead, setCallCenterAdminTeamlead, -1),
                          onIncrement: () =>
                            stepLicence("role_ccadmin", callCenterAdminTeamlead, setCallCenterAdminTeamlead, 1),
                          disabledMinus: (parseInt(String(callCenterAdminTeamlead), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence(
                            "role_ccadmin",
                            parseInt(String(callCenterAdminTeamlead), 10) || 0
                          ),
                          error: errors.role_ccadmin,
                        },
                        {
                          key: "agent",
                          icon: FiUsers,
                          iconModifier: "agent",
                          title: "Total Agent",
                          description: "Total agents allowed",
                          value: parseInt(String(agent), 10) || 0,
                          onChange: (val) => setAgent(validateInput(String(val), "agent")),
                          onDecrement: () => stepLicence("agent", agent, setAgent, -1),
                          onIncrement: () => stepLicence("agent", agent, setAgent, 1),
                          disabledMinus: (parseInt(String(agent), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence("agent", parseInt(String(agent), 10) || 0),
                          error: errors.agent,
                        },
                        {
                          key: "live_agent",
                          icon: FiActivity,
                          iconModifier: "live",
                          title: "Live Agent",
                          description: "Concurrent live agents",
                          value: parseInt(String(liveAgent), 10) || 0,
                          onChange: (val) => setLiveAgent(validateInput(String(val), "live_agent")),
                          onDecrement: () => stepLicence("live_agent", liveAgent, setLiveAgent, -1),
                          onIncrement: () => stepLicence("live_agent", liveAgent, setLiveAgent, 1),
                          disabledMinus: (parseInt(String(liveAgent), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence(
                            "live_agent",
                            parseInt(String(liveAgent), 10) || 0
                          ),
                          error: errors.live_agent,
                        },
                        {
                          key: "channel",
                          icon: FiShare2,
                          iconModifier: "channel",
                          title: "Channels",
                          description: "Communication channels",
                          value: parseInt(String(channel), 10) || 0,
                          onChange: (val) => setChannel(validateInput(String(val), "channel")),
                          onDecrement: () => stepLicence("channel", channel, setChannel, -1),
                          onIncrement: () => stepLicence("channel", channel, setChannel, 1),
                          disabledMinus: (parseInt(String(channel), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence("channel", parseInt(String(channel), 10) || 0),
                          error: errors.channel,
                        },
                        {
                          key: "cps",
                          icon: FiPhone,
                          iconModifier: "channel",
                          title: "CPS",
                          description: "Calls per second",
                          value: parseInt(String(cps), 10) || 0,
                          onChange: (val) => setCps(validateInput(String(val), "cps")),
                          onDecrement: () => stepLicence("cps", cps, setCps, -1),
                          onIncrement: () => stepLicence("cps", cps, setCps, 1),
                          disabledMinus: (parseInt(String(cps), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence("cps", parseInt(String(cps), 10) || 0),
                          error: errors.cps,
                        },
                        {
                          key: "mobile",
                          icon: FiSmartphone,
                          iconModifier: "mobile",
                          title: "Mobile License",
                          description: "Mobile dialer licences",
                          value: parseInt(String(mobile), 10) || 0,
                          onChange: (val) => setMobile(validateInput(String(val), "mobile")),
                          onDecrement: () => stepLicence("mobile", mobile, setMobile, -1),
                          onIncrement: () => stepLicence("mobile", mobile, setMobile, 1),
                          disabledMinus: (parseInt(String(mobile), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence("mobile", parseInt(String(mobile), 10) || 0),
                          error: errors.mobile,
                        },
                        {
                          key: "company",
                          icon: FaBuilding,
                          iconModifier: "company",
                          title: "Company",
                          description: "Additional companies",
                          value: parseInt(String(asCompany), 10) || 0,
                          hidden: isOwnCompany,
                          onChange: (val) => setAsCompany(validateInput(String(val), "company")),
                          onDecrement: () => stepLicence("company", asCompany, setAsCompany, -1),
                          onIncrement: () => stepLicence("company", asCompany, setAsCompany, 1),
                          disabledMinus: (parseInt(String(asCompany), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence("company", parseInt(String(asCompany), 10) || 0),
                          error: errors.company,
                        },
                      ]}
                      availableSummary={
                        loginUserRole !== USER_ROLES.SUPERADMIN ? (
                          <div className="licence-available-summary">
                            <h6 className="licence-available-summary__title">
                              Available Licence (Allocated Company)
                            </h6>
                            <div className="licence-available-summary__row">
                              <span>
                                Call Centers: {parentLicence?.available_licence?.role_ccadmin ?? 0}
                              </span>
                              <span>Agent: {parentLicence?.available_licence?.role_ccagent ?? 0}</span>
                              <span>
                                Live Agent: {parentLicence?.available_licence?.live_agent ?? 0}
                              </span>
                              <span>Channels: {parentLicence?.available_licence?.channel ?? 0}</span>
                              <span>CPS: {parentLicence?.available_licence?.cps ?? 0}</span>
                              <span>Mobile: {parentLicence?.available_licence?.mobile ?? 0}</span>
                              {!isOwnCompany && (
                                <span>Company: {parentLicence?.available_licence?.company ?? 0}</span>
                              )}
                            </div>
                          </div>
                        ) : loginUserRole === USER_ROLES.SUPERADMIN ? (
                          <div className="licence-available-summary">
                            <h6 className="licence-available-summary__title">
                              Available Licence (This Company)
                            </h6>
                            <div className="licence-available-summary__row">
                              <span>Call Centers: {availableLicence?.role_ccadmin ?? 0}</span>
                              <span>Agent: {availableLicence?.role_ccagent ?? 0}</span>
                              <span>Live Agent: {availableLicence?.live_agent ?? 0}</span>
                              <span>Channels: {availableLicence?.channel ?? 0}</span>
                              <span>CPS: {availableLicence?.cps ?? 0}</span>
                              <span>Mobile: {availableLicence?.mobile ?? 0}</span>
                              {!isOwnCompany && (
                                <span>Company: {availableLicence?.company ?? 0}</span>
                              )}
                            </div>
                          </div>
                        ) : null
                      }
                    />

                    <div className="licence-used-summary">
                      <h6 className="licence-used-summary__title">Used Licence (Current Company)</h6>
                      <div className="licence-used-summary__row">
                        <span>Call Centers: {usedLicence?.role_ccadmin ?? 0}</span>
                        <span>Agent: {usedLicence?.role_ccagent ?? 0}</span>
                        <span>Live Agent: {usedLicence?.live_agent ?? 0}</span>
                        <span>Channels: {usedLicence?.channel ?? 0}</span>
                        <span>CPS: {usedLicence?.cps ?? 0}</span>
                        <span>Mobile: {usedLicence?.mobile ?? 0}</span>
                        {!isOwnCompany && <span>Company: {usedLicence?.company ?? 0}</span>}
                      </div>
                    </div>

                    <div className="form-actions company-edit-form__actions">
                    <Button
                      onClick={submitForm}
                      type="button"
                      variant="btn btn-primary"
                      disabled={buttonDisable || Object.values(errors).some((error) => error !== "")}
                    >
                      {buttonDisable ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                          &nbsp; Updating...
                        </>
                      ) : (
                        "Update Company"
                      )}
                    </Button>
                    </div>

                  </form>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

    </>
  )

}

export default CompanyUpdate;
